import { Box } from "@chakra-ui/react";
import { ColorIcon, customEvent, Spacing } from "goi_common";
import { useState } from "react";
import { BaseStack, baseColors } from "goi_common/src/design-system";

import MubinsoQuickCard from "./MubinsoQuickCard";

/**
 * 4-way ① sub2 하단 CTA: "간소화된 장례를 원하신다면? / 무빈소 가능한 장례식장 알아보기".
 * 클릭 시 무빈소 빠른 폼(MubinsoQuickCard purpose=mubinso)을 인라인으로 펼침.
 */
interface MubinsoInlineCTAProps {
  defaultSido?: number | null;
  defaultSigungu?: number | null;
}

function MubinsoInlineCTA({ defaultSido = null, defaultSigungu = null }: MubinsoInlineCTAProps) {
  const [open, setOpen] = useState(false);

  return (
    <BaseStack
      width="100%"
      borderRadius="12px"
      border={`1px solid ${baseColors.line_normal}`}
      bg={baseColors.background_normal}
      overflow="hidden"
    >
      <Box
        as="button"
        textAlign="left"
        cursor="pointer"
        width="100%"
        display="flex"
        alignItems="center"
        gap="12px"
        padding="16px 18px"
        background={open ? baseColors.fill_normal : baseColors.background_normal}
        borderBottom={open ? `1px solid ${baseColors.line_normal}` : "none"}
        onClick={() => {
          customEvent({
            newGtm: { path: "parlor_region", trigger_and_target: "mubinso_btm-toggle" },
          });
          setOpen((v) => !v);
        }}
      >
        <Box flex={1}>
          <Box className="label_1_r" color={baseColors.label_assistive_2}>
            간소화된 장례를 원하신다면?
          </Box>
          <Spacing gap={2} />
          <Box className="body_1_normal_sb" color={baseColors.label_normal} wordBreak="keep-all">
            <Box color={baseColors.orange_600}>무빈소 가능한</Box> 장례식장 알아보기
          </Box>
        </Box>
        <Box
          flexShrink={0}
          transform={open ? "rotate(180deg)" : "rotate(0deg)"}
          transition="transform 0.2s"
        >
          <ColorIcon name="arrow_circle_down" width="24px" height="24px" color={""} />
        </Box>
      </Box>

      {open && (
        <Box padding="0 18px 18px">
          {/*
           * 이 폼도 지역 로그인 실험(#333) 모수다. 지역 페이지 안에서 열리고 지역을 받아
           * 제출하므로 상단 폼과 같은 지역 맥락이다.
           *
           * serviceKey 는 "무빈소" 고정이다. 사용자가 "무빈소 가능한 장례식장 알아보기"를
           * 눌러 이 폼으로 제출했으면 페이지 유형과 무관하게 무빈소 의도를 따른다.
           */}
          <MubinsoQuickCard
            variant="card"
            purpose="mubinso"
            defaultSido={defaultSido}
            defaultSigungu={defaultSigungu}
            loginEventFrom="uv_rgn_form"
            regionQuoteServiceKey="무빈소"
          />
        </Box>
      )}
    </BaseStack>
  );
}

export default MubinsoInlineCTA;
